import {
	Check as CheckIcon,
	ContentCopy as ContentCopyIcon,
} from "@mui/icons-material";
import { Alert, IconButton, Tooltip } from "@mui/material";
import type { AlertColor } from "@mui/material/Alert/Alert";
import Snackbar, { type SnackbarCloseReason } from "@mui/material/Snackbar";
import {
	type Dispatch,
	type SetStateAction,
	type SyntheticEvent,
	useState,
} from "react";

interface SnackbarComponentProps {
	message?: string;
	open: boolean;
	severity: AlertColor;
	setOpen: Dispatch<SetStateAction<boolean>>;
}

const SnackbarComponent = ({
	message,
	setOpen,
	severity,
	open,
}: SnackbarComponentProps) => {
	const [copied, setCopied] = useState(false);
	const hasTraceId = /traceid\s*:/i.test(message ?? "");

	const handleClose = (
		_event?: SyntheticEvent | Event,
		reason?: SnackbarCloseReason,
	) => {
		if (reason === "clickaway") {
			return;
		}

		setOpen(false);
		setTimeout(() => setCopied(false), 300);
	};

	const handleCopy = (e: SyntheticEvent) => {
		e.stopPropagation();
		if (hasTraceId && message) {
			navigator.clipboard.writeText(message);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		}
	};

	return (
		<Snackbar
			sx={{ zIndex: 99999999 }}
			open={open}
			autoHideDuration={hasTraceId ? 15000 : 6000}
			onClose={handleClose}
		>
			<Alert
				onClose={handleClose}
				severity={severity}
				variant="filled"
				sx={{
					width: "100%",
					"& .MuiAlert-message": {
						display: "flex",
						alignItems: "center",
						gap: 1,
					},
				}}
				action={
					hasTraceId ? (
						<Tooltip title={copied ? "Copiado!" : "Copiar mensagem"}>
							<IconButton
								size="small"
								aria-label="copy"
								color="inherit"
								onClick={handleCopy}
							>
								{copied ? (
									<CheckIcon fontSize="small" />
								) : (
									<ContentCopyIcon fontSize="small" />
								)}
							</IconButton>
						</Tooltip>
					) : undefined
				}
			>
				{message}
			</Alert>
		</Snackbar>
	);
};

export default SnackbarComponent;
